<i18n locale="en">
{
  "labels": {
    "new-label": "New to Owner?",
    "new-link": "Book a Demo"
  }
}
</i18n>
<template>
  <div class="post-button-actions flex-row justify-start">
    <AuthLabeledLink
      justify="start"
      :label="t('labels.new-label')"
      :link-text="t('labels.new-link')"
      :link="BOOK_DEMO_URL"
    />
  </div>
</template>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const LANDING_URL = import.meta.env.VITE_LANDING_URL

import AuthLabeledLink from '../common/AuthLabeledLink.vue'

const { t } = useI18n()

const BOOK_DEMO_URL = encodeURI(`${LANDING_URL}/contact`)
</script>
<style lang="scss" scoped>
.post-button-actions {
  height: 24px;
}
</style>
